export enum EncryptionContext {
  RealtimeMessage = 'rts',
  PersistentComment = 'comment',
  LocalStorage = 'localstorage',
}
